'use es6';

import PropTypes from 'prop-types';
import { BaseResponsiveColumnToolbar, buildActionsForColumn } from './BaseResponsiveColumnToolbar';
import ColumnIcon from './ColumnIcon';
import { jsx as _jsx } from "react/jsx-runtime";
const MockResponsiveMobileColumnToolbarToMeasure = ({
  responsiveSize,
  isInNonDefaultBreakpointMode,
  isInDeveloperMode
}) => {
  return /*#__PURE__*/_jsx(BaseResponsiveColumnToolbar, {
    active: false,
    icon: ColumnIcon,
    actions: buildActionsForColumn({
      isInDefaultBreakpointMode: !isInNonDefaultBreakpointMode,
      isInDeveloperMode
    }),
    responsiveSize: responsiveSize
  });
};
MockResponsiveMobileColumnToolbarToMeasure.propTypes = {
  responsiveSize: PropTypes.string.isRequired,
  isInNonDefaultBreakpointMode: PropTypes.bool.isRequired,
  isInDeveloperMode: PropTypes.bool
};
const MockResponsiveDesktopColumnToolbarToMeasure = ({
  responsiveSize,
  isInNonDefaultBreakpointMode,
  isInDeveloperMode
}) => {
  return /*#__PURE__*/_jsx(BaseResponsiveColumnToolbar, {
    active: false,
    icon: ColumnIcon,
    actions: buildActionsForColumn({
      isInDefaultBreakpointMode: !isInNonDefaultBreakpointMode,
      isInDeveloperMode
    }),
    responsiveSize: responsiveSize
  });
};
MockResponsiveDesktopColumnToolbarToMeasure.propTypes = {
  responsiveSize: PropTypes.string.isRequired,
  isInNonDefaultBreakpointMode: PropTypes.bool.isRequired,
  isInDeveloperMode: PropTypes.bool
};
export { MockResponsiveMobileColumnToolbarToMeasure, MockResponsiveDesktopColumnToolbarToMeasure };